<ng-container [ngSwitch]="workflowStateType">
  <mat-icon *ngSwitchCase="workflowStateTypeEnum.Start" class="state-icon start">not_started</mat-icon>
  <mat-icon *ngSwitchCase="workflowStateTypeEnum.Completed" class="state-icon completed">verified</mat-icon>
  <mat-icon *ngSwitchCase="workflowStateTypeEnum.Failed" class="state-icon failed">dangerous</mat-icon>
  <mat-icon *ngSwitchCase="workflowStateTypeEnum.Retired" class="state-icon retired">stop_circle</mat-icon>
  <mat-icon *ngSwitchCase="workflowStateTypeEnum.Paused" class="state-icon paused">pause_circle</mat-icon>
  <mat-icon *ngSwitchDefault class="state-icon in-progress">pending</mat-icon>
</ng-container>